import styles from './PageProductHeroGradientOverlay.module.css';
import classNames from 'classnames';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';

function PageProductHeroGradientOverlay() {
  const {
    showHeroGradientOverlayDesktop,
    showHeroGradientOverlaySmallDesktop,
    showHeroGradientOverlayTablet,
    showHeroGradientOverlayMobile,
  } = useSearchParamOrDefaultProps();
  const showDesktopOverlay = showHeroGradientOverlayDesktop === 'true';
  const showSmallDesktopOverlay =
    showHeroGradientOverlaySmallDesktop === 'true';
  const showTabletOverlay = showHeroGradientOverlayTablet === 'true';
  const showMobileOverlay = showHeroGradientOverlayMobile === 'true';

  return (
    <div
      className={classNames(styles.PageProductHeroGradientOverlay, {
        [styles.showHeroGradientOverlayDesktop]: showDesktopOverlay,
        [styles.hideHeroGradientOverlayDesktop]: !showDesktopOverlay,
        [styles.showHeroGradientOverlaySmallDesktop]: showSmallDesktopOverlay,
        [styles.hideHeroGradientOverlaySmallDesktop]: !showSmallDesktopOverlay,
        [styles.showHeroGradientOverlayTablet]: showTabletOverlay,
        [styles.hideHeroGradientOverlayTablet]: !showTabletOverlay,
        [styles.showHeroGradientOverlayMobile]: showMobileOverlay,
        [styles.hideHeroGradientOverlayMobile]: !showMobileOverlay,
      })}
    />
  );
}

export default PageProductHeroGradientOverlay;
